const post = async (path, body) => {
    const response = await fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(result.error || 'REQUEST_FAILED');
    }

    return result;
};

// Resolves with { code, token }
export const createGame = (input) => (
    post('/api/games', input)
);

export const sendFeedback = (input) => (
    post('/api/feedback', input)
);
